import React,{useState,useEffect,useRef}from 'react'
import { Modal,Form,Input, App, } from 'antd';
import Icon from '../../../cpn/Icon';
import { useShoukuanlxUpdateSaveMutation } from '../../../store/DianShangYeWuApi';    
function IncomeTypeEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        sklx_name:props.sklx_name,
        sklx_qy_id:props.qy_id,
        sklx_qy_name:props.qy_name,
        sklx_cid:props.yh_id,
        sklx_cname:props.yh_name,
        sklx_id:props.sklx_id,
    }); 
    const editForm = useRef()
    useEffect(() => {
        if(editForm.current){   
            editForm.current.setFieldsValue({
                sklx_name:props.sklx_name,
            })   
        }
    },[open ,props.sklx_name])
    const [sklxEdit] = useShoukuanlxUpdateSaveMutation()    
    return (
        <>
            <Icon type='edit' onClick={() => {setOpen(true)}} />
            <Modal
                width={1000}                        
                open={open}
                title='修改收款类型'
                okText="保存"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {                    
                    form
                        .validateFields()
                        .then((values) => {
                            sklxEdit(info).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功')   
                                    setOpen(false);
                                    form.resetFields();
                                    onCreateEdit(values);
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败：'+res.data.Message)
                                }
                            })
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_sklx_edit_${props.yh_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <Form.Item name="sklx_name" wrapperCol={{span:4}} required label='名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,sklx_name:e.target.value}))
                        }}/>
                    </Form.Item>                                           
                </Form>
            </Modal>
        </>
    )
}

export default IncomeTypeEdit